<app-login style="background-color:#5CC5BA;" *ngIf="!login"></app-login>
<app-navigation *ngIf="login"></app-navigation>
